<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="修改用户数据" name="1">
      <UserAdd :updataID='updataID'></UserAdd>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import UserAdd from '../../../../static/form/UserAdd.vue'
export default {
  components: {
    UserAdd
  },
  data()
  {
    return {
      activeName: '1',
      updataID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/Usergl'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/UserUpdate.vue